// @flow
import api, { buildHeaders } from 'common/services/api';
import { SalesMember } from '../domain/SalesMember';

class SalesMembersApi {

  async fetchSalesMembers(token: string, callSign: string): Promise<SalesMember[]> {
    const url = `/statsradio/${callSign}/sales-members`;

    const { data }: { data: SalesMember[] } = await api.get(url, {}, { headers: buildHeaders(token) });

    return data.map(datum => SalesMember.parse(datum));
  }
}

export default new SalesMembersApi();



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesMembers/services/SalesMembersApi.js